import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "questions-content-wrapper" }
const _hoisted_2 = { class: "question" }
const _hoisted_3 = { class: "question-text" }
const _hoisted_4 = { class: "answer" }
const _hoisted_5 = { class: "vue-slider-tooltip-top vue-slider-tooltip-wrap" }
const _hoisted_6 = { class: "vue-slider-tooltip" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "scale" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Strongly "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Disagree")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Disagree"),
  /*#__PURE__*/_createElementVNode("span", null, "Agree"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Strongly "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Agree")
  ])
], -1)
const _hoisted_8 = { class: "questions-footer" }
const _hoisted_9 = { class: "questions-progress" }
const _hoisted_10 = ["disabled"]

import { computed, onMounted, ref, watch } from "vue";
import VueSlider from "vue-3-slider-component";
import { Modal } from "uiv";
import { debug as d } from "debug";
import { DevelopQuestion } from "../../services/cms/develop-question";
import { Analytics } from "../../services/analytics/analytics";

// import "vue-slider-component/dist-css/vue-slider-component.css";
// import "vue-slider-component/theme/default.css";

const initialValue = 5.5;


export default /*#__PURE__*/_defineComponent({
  __name: 'questions-modal',
  props: {
    showModal: { type: Boolean },
    onSubmit: { type: Function },
    onCancel: { type: Function },
    questions: {}
  },
  setup(__props: any) {

const debug = d("cs.QuestionsComponent");

const props = __props;

const choices = Array(10).map((_, i) => i + 1); // Numbers 1 - 10

const currentQuestionIndex = ref(0);

const answers = ref<Record<string, number>>({ 0: 1 });

const sliderHasBeenTouched = ref(false);

const dialogShown = ref(false);

const hasValidationError = ref(false);

watch(
  () => props.showModal,
  (newValue: boolean) => {
    dialogShown.value = newValue;
  },
);

const currentQuestion = computed(() => props.questions[currentQuestionIndex.value]);

const currentAnswer = computed(() => answers.value[currentQuestionIndex.value]);

function submit(): void {
  const answersArray = Object.values(answers.value);
  if (answersArray.every((value) => value > 0)) {
    hasValidationError.value = false;
    props.onSubmit(answersArray);
  } else {
    hasValidationError.value = true;
  }
}

function previous(): void {
  if (currentQuestionIndex.value > 0) {
    Analytics.action("Questionnaire Previous Question", "QuestionnaireQuestionActions", {
      fromQuestionNumber: currentQuestionIndex.value + 1,
    });
    currentQuestionIndex.value -= 1;
    sliderHasBeenTouched.value = true; // The previous question must have been answered
  }
}

function next(): void {
  if (currentQuestionIndex.value < props.questions.length - 1) {
    Analytics.action("Questionnaire Next Question", "QuestionnaireQuestionActions", {
      fromQuestionNumber: currentQuestionIndex.value + 1,
    });
    currentQuestionIndex.value += 1;
    sliderHasBeenTouched.value = !!currentAnswer.value && currentAnswer.value !== initialValue;
  } else {
    // Must be the last question
    submit();
  }
}

function cancel(): void {
  props.onCancel();
}

function handleDialogHide(): void {
  if (props.showModal) {
    cancel();
  }
}

function sliderChanged(value: number): void {
  sliderHasBeenTouched.value = true;
}

onMounted(() => {
  props.questions.forEach((q, i) => {
    answers.value[i] = initialValue;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    class: "questions-dialog text-left",
    modelValue: dialogShown.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogShown).value = $event)),
    title: "Self-review",
    onHide: handleDialogHide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn btn-lg btn-primary", { invisible: currentQuestionIndex.value === 0 }]),
          onClick: previous,
          type: "button"
        }, " Previous ", 2),
        _createElementVNode("div", _hoisted_9, _toDisplayString(currentQuestionIndex.value + 1) + " / 6", 1),
        _createElementVNode("button", {
          class: "btn btn-lg btn-primary",
          disabled: !sliderHasBeenTouched.value,
          onClick: next,
          "test-id": "questions-next-button",
          type: "button"
        }, _toDisplayString(currentQuestionIndex.value === _ctx.questions.length - 1 ? "Done" : "Next"), 9, _hoisted_10)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, "I " + _toDisplayString(currentQuestion.value.wording), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(VueSlider), {
              ref: "slider",
              min: 1,
              max: 10,
              interval: 1,
              lazy: true,
              piecewise: true,
              speed: 0.3,
              tooltip: sliderHasBeenTouched.value ? 'always' : false,
              "dot-size": 40,
              marks: true,
              absorb: true,
              modelValue: answers.value[currentQuestionIndex.value],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answers.value[currentQuestionIndex.value]) = $event)),
              onChange: sliderChanged
            }, {
              tooltip: _withCtx((tooltip) => [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round(+tooltip.value)), 1)
                ])
              ]),
              _: 1
            }, 8, ["tooltip", "modelValue"]),
            _withDirectives(_createElementVNode("input", {
              "test-id": "question-hidden-input",
              style: {"visibility":"hidden","display":"none"},
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((answers.value[currentQuestionIndex.value]) = $event)),
              "aria-hidden": "true"
            }, null, 512), [
              [_vModelText, answers.value[currentQuestionIndex.value]]
            ]),
            _hoisted_7
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})